import React from 'react';
import clsx from 'clsx';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import qs from 'query-string';
import SearchButton from '../../components/atoms/SearchButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  GET_LIST_SETTING_MENU_FREE_SUCCESS,
  getListSettingMenuFree
} from '../../actions/GochiMenus';
import { getAccounts } from '../../actions/Accounts';
import { getShops } from '../../actions/Shop';
import { getOptionShops } from '../../actions/Options';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import GochiKidMenuFreeTableGroup from '../organisms/GochiKidMenuFreeTableGroup';

const styles = theme => ({
  root: {
    display: 'flex'
  },
  mainPaper: {
    position: 'relative',
    margin: '20px 0px',
    minWidth: 1024
  },
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10,
    color: '#000000'
  },
  rowForm: {
    display: 'flex',
    marginLeft: '-5px',
    marginRight: '-5px',
    flexWrap: 'wrap'
  },
  formControl: {
    paddingLeft: 5,
    paddingRight: 5,
    marginBottom: 15,
    width: '20%'
  },
  textField: {
    position: 'relative'
  },
  tableContainer: {
    position: 'relative',
    marginTop: 15,
    paddingTop: 10
  },
  toolbar: {
    display: 'flex',
    fontSize: 24,
    fontWeight: 'bold'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    width: 'calc(100% - 240px)',
    minWidth: 1024
  },
  formLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: '#000'
  },
  buttonSearch: {
    margin: '22px 0 0 10px',
    height: 38
  },
  backLink: {
    textDecoration: 'underline'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      showHides: state.gochiMenus.showHide.map(el =>
        el.id === '' ? { ...el, name: '選択してください' } : el
      ),
      menuChildTypes: state.gochiMenus.menuChildType,
      menuGenre: state.options.listMenuGenre,
      menuSituation: state.options.listMenuSituation,
      menuUserTarget: state.options.listMenuUserTarget
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getListSettingMenuFree,
          getAccounts,
          getShops,
          getOptionShops
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'updateOpenAdd', false),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('openViewOrderCustom', 'updateOpenViewOrderCustom', false),
  withState('openViewOrderCustomList', 'updateOpenViewOrderCustomList', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDelete', 'updateOpenDelete', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('orderMenuShopId', 'setOrderMenuShopId', ''),
  withState('groupName', 'setGroupName', ''),
  withState('shopName', 'setShopName', ''),
  withState('shopId', 'setShopId', null),
  withState('menuName', 'setMenuName', ''),
  withState('menuId', 'setMenuId', ''),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 10),
  withState('showHide', 'setShowHide', ''),
  withState('menuChildType', 'setMenuChildType', ''),
  withState('menuGenre', 'setMenuGenre', []),
  withState('menuSituation', 'setMenuSituation', []),
  withState('menuUserTarget', 'setMenuUserTarget', []),
  withState('menuSystemFlag', 'setMenuSystemFlag', ''),
  withState('paramSubmitted', 'setParamSubmitted', null),
  withState('totalMenu', 'setTotalMenu', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangePage: props => (event, page, limit, params) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 10;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }

      const searchKey = {
        shopName: props.shopName,
        menuName: props.menuName,
        shopId: props.shopId,
        menuId: props.menuId,
        page,
        limit: limitNum,
        ...params
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getListSettingMenuFree(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === GET_LIST_SETTING_MENU_FREE_SUCCESS) {
            props.setParamSubmitted(searchKey);
            props.setTotalMenu(data.payload.totalCount);
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      const url = window.location.search;
      const { shopId } = qs.parse(url);
      this.props.setShopId(shopId);
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.updateOpenTable(true);
        this.props.handleChangePage(null, 1, this.props.rowsPerPage, {
          shopId
        });
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    handleChangePage,
    openTable,
    updateOpenTable,
    loading,
    openProgress,
    updateOpenProgress,
    shopId,
    setShopId,
    shopName,
    setShopName,
    menuName,
    setMenuName,
    menuId,
    setMenuId,
    resultMessage,
    page,
    paramSubmitted,
    totalMenu
  }) => {
    const rowsPerPage = document.getElementById('rowsPerPage');
    let limitNum = 10;
    if (rowsPerPage) {
      limitNum = rowsPerPage.textContent;
    }

    const searchKey = {
      shopName,
      menuName,
      shopId,
      menuId,
      page,
      limit: limitNum
    };
    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, limitNum);
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };
    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="こども ごちめし" />
        <main className={classes.content}>
          <div className={classes.toolbar}>こども ごちめし</div>
          {paramSubmitted &&
          !paramSubmitted.shopId &&
          !paramSubmitted.shopName &&
          !paramSubmitted.menuId &&
          !paramSubmitted.menuName &&
          totalMenu === 0 ? null : (
            <Paper className={classes.mainPaper} elevation={1}>
              <div className={classes.searchForm}>
                <div className={classes.rowForm}>
                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>店舗ID</FormLabel>
                    <TextField
                      placeholder="例) 0123"
                      type="search"
                      className={classes.textField}
                      variant="outlined"
                      size="small"
                      value={shopId}
                      onChange={e => {
                        setShopId(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </FormControl>

                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>店舗名</FormLabel>
                    <TextField
                      placeholder="例) Gigi 〇〇店"
                      type="search"
                      className={classes.textField}
                      variant="outlined"
                      size="small"
                      value={shopName}
                      onChange={e => {
                        setShopName(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </FormControl>

                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>
                      メニューID
                    </FormLabel>
                    <TextField
                      placeholder="例) 0123"
                      type="search"
                      className={classes.textField}
                      variant="outlined"
                      size="small"
                      value={menuId}
                      onChange={e => {
                        setMenuId(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </FormControl>

                  <FormControl
                    className={clsx(classes.margin, classes.formControl)}
                    variant="outlined"
                    size="small"
                  >
                    <FormLabel className={classes.subTitle}>
                      メニュー名
                    </FormLabel>
                    <TextField
                      placeholder="例) とんかつ定食"
                      type="search"
                      className={classes.textField}
                      variant="outlined"
                      size="small"
                      value={menuName}
                      onChange={e => {
                        setMenuName(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </FormControl>

                  <SearchButton
                    customStyles={classes.buttonSearch}
                    onClickAction={searchAction}
                  />
                </div>
              </div>
            </Paper>
          )}

          <div className={classes.tableContainer}>
            <GochiKidMenuFreeTableGroup
              searchKey={searchKey}
              page={page}
              handleChangePage={handleChangePage}
              selectedPage={page}
              openTable={openTable}
              paramSubmitted={paramSubmitted}
            />
          </div>
        </main>

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
